import React, { useState } from 'react';

import HeaderBase from './components/HeaderBase';
import HeaderSimple from './components/HeaderSimple';
import HeaderSprings from './components/HeaderSprings';
// import Main from './components/Main';

import './App.css';

function App() {
  const [view] = useState(1);
  let header;
  switch (view) {
    case 2:
      header = <HeaderSimple />;
      break;
    case 3:
      header = <HeaderBase />;
      break;
    case 1:
    default:
      header = <HeaderSprings />;
      break;
  }
  return <div>{header}</div>;
}

export default App;
